export default "__VITE_ASSET__Cwrcp8Cf__"